// extracted by mini-css-extract-plugin
export default {"input":"Blogs_input__XaXx2"};